import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

function GraficoPizza({ historico }) {
  const categorias = { abaixo: 0, normal: 0, sobrepeso: 0, obesidade: 0 };

  historico.forEach((item) => {
    const valor = parseFloat(item.valor);
    if (valor < 18.5) categorias.abaixo++;
    else if (valor < 24.9) categorias.normal++;
    else if (valor < 29.9) categorias.sobrepeso++;
    else categorias.obesidade++;
  });

  const isMobile = window.innerWidth < 600;

  const labelsDesktop = [
    "😟 Abaixo do peso",
    "🙂 Peso normal",
    "😐 Sobrepeso",
    "😰 Obesidade"
  ];
  const labelsMobile = [
    "😟 Abaixo",
    "🙂 Normal",
    "😐 Sobrepeso",
    "😰 Obesidade"
  ];

  const data = {
    labels: isMobile ? labelsMobile : labelsDesktop,
    datasets: [
      {
        data: [
          categorias.abaixo,
          categorias.normal,
          categorias.sobrepeso,
          categorias.obesidade
        ],
        backgroundColor: ["orange", "green", "purple", "red"],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: isMobile ? "right" : "bottom",
        labels: {
          font: {
            size: isMobile ? 11 : 14,
            weight: isMobile ? "bold" : "normal",
          },
          color: "black",
          boxWidth: isMobile ? 16 : 20,
          padding: isMobile ? 8 : 15,
        },
      },
    },
  };

  return (
    <div className="grafico-pizza">
      <h3>Distribuição dos IMCs</h3>
      <Pie data={data} options={options} />
    </div>
  );
}

export default GraficoPizza;